import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { OAuthResourceServerErrorHandler } from 'angular-oauth2-oidc';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements OAuthResourceServerErrorHandler {
  constructor() {
    console.log('AuthInterceptor initialized');
  }

  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   let authReq = req;
  //   // const token = this.cognitoService.getAccessToken();
  //   let token = null;
  //   if (token != null) {
  //     // for Spring Boot back-end
  //     // authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
  //     // for Node.js Express back-end
  //     // authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, token) });
  //   }
  //   return next.handle(authReq).pipe(catchError(x => this.handleAuthError(x)));
  // }

  private handleAuthError(err: HttpResponse<unknown>): Observable<never> {
    if(!environment.production){
        console.log('Error in AuthInterceptor', err);
        return throwError(() => err);
    }
    //handle your auth error or rethrow
    if (err.status === 401 || err.status === 403) {
      console.log(err, 'Unauthorized!');

      return throwError(() => err);
      //navigate /delete cookies or whatever
      // this.router.navigateByUrl(`/login`);
      // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
    } else {
      return throwError(() => err);
    }
  }

  handleError(err: HttpResponse<unknown>): Observable<never> {
    return this.handleAuthError(err);
  }
}

export const authInterceptorProviders = [
  { provide: OAuthResourceServerErrorHandler, useClass: AuthInterceptor, multi: false },
];
